import axios from 'axios'

export default {
    namespaced: true,
    state: {
        courses: [],
    },
    mutations: {
        SET_COURSES(state, payload) {
            state.courses = payload;
        },
    },
    actions: {
        FetchCoursesByCourseCodes({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/courses/fetch/course-codes`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_COURSES', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchCoursesByCourseCodes: ${error.response.data || error.message}`));
            });
        },
    },
    getters: {
        Courses(state) { return state.courses; },
    },
};
